// import { Description } from "@material-ui/icons";

export const experienceData = [
    {
        id: 1,
        company: 'Northeastern University',
        jobtitle: 'Bioinformatics and Machine Learning Co-op',
        startYear: 'Jul 2024',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'Revelations Biotech Pvt Ltd',
        jobtitle: 'Quality Control Microbiologist',
        startYear: 'Jan 2022',
        endYear: 'May 2022'
    },
    {
        id: 3,
        company: 'Indian Institute of Technology',
        jobtitle: 'Systems Biology Intern',
        startYear: 'Jun 2019',
        endYear: 'Jul 2019'
    }
]